import { useEffect } from 'react';
import './banner.css';

type Props = {
  handlePPClick: (e: MouseEvent) => void;
  textContent?: string;
};

function updateBannerView(handlePPClick: Props['handlePPClick'], textContent?: string) {
  const policyContainer = document.getElementById('onetrust-policy') as HTMLElement;
  const policyText = document.getElementById('onetrust-policy-text') as HTMLElement;
  if (!policyContainer || !policyText) return;

  policyText.classList.add('collapsed');

  const policyAnchor = policyText.getElementsByTagName('a')[0];
  if (policyAnchor) {
    policyAnchor.onclick = handlePPClick;
  }

  let showMoreAnchor = document.getElementById('show-more') as HTMLAnchorElement;

  if (!showMoreAnchor) {
    showMoreAnchor = document.createElement('a');
    showMoreAnchor.href = '#';
    showMoreAnchor.textContent = textContent ?? null;
    showMoreAnchor.setAttribute('id', 'onetrust-banner-show-more');
    showMoreAnchor.onclick = () => {
      policyText.classList.remove('collapsed');
      policyContainer.removeChild(showMoreAnchor);
      return false;
    };

    policyContainer.appendChild(showMoreAnchor);
  }

  const logo = document.querySelector<HTMLImageElement>('.ot-pc-logo');
  logo?.remove();
}

export default function CookieBannerObserver({ textContent, handlePPClick }: Props) {
  useEffect(() => {
    const obs = new MutationObserver(() => {
      const rootContainer = document.getElementById('onetrust-consent-sdk') as HTMLElement;

      if (rootContainer) {
        updateBannerView(handlePPClick, textContent);
      }
    });

    obs.observe(document.body, { childList: true });

    return () => {
      obs.disconnect();
    };
  }, []);

  return null;
}
